import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';



type Props = {
    first?: boolean,
    index: number,
    blockIndex: number,
    count: number,
    onRemove: () => void,
    onChange: (blockIndex: number, index: number, newData: SearchValue) => void,
    data: SearchValue
}

function SearchField({ first, blockIndex, index, count, onRemove, onChange, data }: Props) {

    const changeData = (key: keyof SearchValue, value: any) => {
        const newData = { ...data };
        newData[key] = value as never;
        onChange(blockIndex, index, newData);
    }

    return (<>

        <div className="w-full flex items-center">
            {!first &&
                <Select
                    labelId=""
                    id=""
                    value={data.operator}
                    onChange={(v) => changeData("operator", v.target.value)}
                    size="small"
                    sx={{ mr: 2 }}
                >
                    <MenuItem value="and">E também (AND)</MenuItem>
                    <MenuItem value="or">Ou (OR)</MenuItem>
                </Select>
            }
            <div className="">
                <Select
                    labelId=""
                    id=""
                    value={data.mapping}
                    onChange={(v) => changeData("mapping", v.target.value)}
                    size="small"
                >
                    <MenuItem value="all-words">Todas as palavras</MenuItem>
                    <MenuItem value="at-least-one">Pelo menos uma das palavras</MenuItem>
                    <MenuItem value="not-contain">Não contendo as palavras</MenuItem>
                    <MenuItem value="exact">Com a frase exata</MenuItem>
                </Select>
            </div>

            <FormControl fullWidth sx={{ ml: 2 }}>
                <TextField id="outlined-basic" size='small' placeholder='Digite uma ou mais palavras-chave' variant="outlined" value={data.query}
                    onChange={(ev: { target: { value: any; }; }) => changeData('query', ev.target.value)} />

            </FormControl>
            {count > 1 ?

                <IconButton aria-label="delete" color="error" onClick={onRemove}>
                    <RemoveCircleIcon />
                </IconButton>

                : null}
        </div>
    </>);
}

export default SearchField;
